import { Component, OnInit, Input } from '@angular/core';
import { Product } from '@infrab4a/connect';

@Component({
  selector: 'mens-products-card',
  templateUrl: './product-card.component.html',
  styleUrls: ['./product-card.component.scss']
})
export class ProductCardComponent implements OnInit {

  @Input() product: Product;

  constructor() { }

  ngOnInit(): void {
  }

  private getRatingAvg(product: Product): number {
    const totalReviews = product.reviews?.filter(r => r.status).length || 0;
    const totalReviewsSum = totalReviews
      ? product.reviews
          ?.filter(r => r.status)
          .reduce((sum, review) => (sum += review.rate), 0) / totalReviews
      : 0;

    return Math.trunc(totalReviewsSum);
  }

  getStarRating(product: Product, index: number) {
    let render = 'outline';

    if (this.getRatingAvg(product) > index) {
      render = 'fill';
    }

    return render;
  }

}
